module.exports = __webpack_public_path__ + "static/media/9_Tomas_M@2x.aef35e7e.jpg";